/**
 * Periyot katalog modülü sabitleri.
 *
 * Tekrar aralığı tanımlarının (CRUD) yönetimi. Her periyot `interval_value × interval_unit`
 * kadar bir tekrar aralığı tanımlar (ör. 30×MINUTE = yarım saatte bir). Periyodik üretim
 * formundaki "Periyot" dropdown'unu besler (yalnız aktif olanlar).
 */

export const periodEndpoints = {
  // `status` ALL ise durum filtresi eklenmez; ACTIVE/PASSIVE → is_active true/false.
  list: (page: number, query: string, status?: string) => {
    const filters = [`name:${encodeURIComponent(query)}`]
    if (status === 'ACTIVE') filters.push('is_active:true')
    if (status === 'PASSIVE') filters.push('is_active:false')
    return `/periods?page=${page}&filters=${filters.join(',')}` // GET
  },
  options: '/periods/options', // GET (periyodik üretim dropdown'u; aktif periyotlar)
  create: '/periods', // POST
  detail: (id: string) => `/periods/${id}`, // GET
  update: (id: string) => `/periods/${id}`, // PATCH
  activate: (id: string) => `/periods/${id}/activate`, // POST
  passive: (id: string) => `/periods/${id}/passive`, // POST
  remove: (id: string) => `/periods/${id}`, // DELETE
} as const

export const PERIOD_LIST_KEY = ['periodList'] as const
export const PERIOD_OPTIONS_KEY = ['periodOptions'] as const

/** Liste durum filtresi (Hepsi/Aktif/Pasif). `ALL` filtresizdir. */
export const periodStatusFilterOptions = {
  ALL: 'Hepsi',
  ACTIVE: 'Aktif',
  PASSIVE: 'Pasif',
} as const

export type TPeriodStatusFilter = keyof typeof periodStatusFilterOptions

/** Tekrar aralığı birimleri (backend `IntervalUnitEnum`). Form Select'ini besler. */
export const intervalUnitOptions = {
  MINUTE: 'Dakika',
  HOUR: 'Saat',
  DAY: 'Gün',
  WEEK: 'Hafta',
  MONTH: 'Ay',
} as const

export type TIntervalUnit = keyof typeof intervalUnitOptions

const intervalSuffix: Record<TIntervalUnit, string> = {
  MINUTE: 'dakikada bir',
  HOUR: 'saatte bir',
  DAY: 'günde bir',
  WEEK: 'haftada bir',
  MONTH: 'ayda bir',
}

/** İnsan-okunur tekrar aralığı (ör. 30 → "30 dakikada bir", 1 HOUR → "1 saatte bir"). */
export function formatInterval(value: number, unit: TIntervalUnit): string {
  return `${value} ${intervalSuffix[unit] ?? unit}`
}

export const periodSuccessMessages = {
  created: 'Periyot oluşturuldu.',
  updated: 'Periyot güncellendi.',
  activated: 'Periyot aktifleştirildi.',
  passivated: 'Periyot pasife alındı.',
  deleted: 'Periyot silindi.',
} as const

/** Backend `PeriodResponseStatusEnum` + `GeneralCrudErrors` kodları. */
export const periodBackendErrors = {
  GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  PERIOD_NOT_FOUND: 'Periyot bulunamadı.',
  PERIOD_NAME_EXISTS: 'Bu isimde bir periyot zaten var.',
  PERIOD_INTERVAL_EXISTS: 'Bu tekrar aralığında bir periyot zaten var.',
  PERIOD_IN_USE:
    'Bu periyot bir veya daha fazla periyodik üretimde kullanılıyor; önce o periyodik üretimleri silin ya da periyodu pasife alın.',
} as const
